import { render, staticRenderFns } from "./DocumentReduceDetails.vue?vue&type=template&id=a50826b8&scoped=true&"
import script from "./DocumentReduceDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentReduceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50826b8",
  null
  
)

export default component.exports